import React, { useState } from "react";
import { Box, Typography, Tabs, Tab } from "@mui/material";
import DataTable from "../components/DataTable";
const sampleOrders = [
    { orderId: "ORD001", date: "2026-03-06", customer: "John Doe", total: 115500, status: "Completed" },
    { orderId: "ORD002", date: "2026-03-06", customer: "Jane Smith", total: 25000, status: "Pending" }
];
const sampleInvoices = [
    { invoiceId: "INV001", date: "2026-03-06", customer: "John Doe", totalAmount: 115500 },
    { invoiceId: "INV002", date: "2026-03-06", customer: "Jane Smith", totalAmount: 25000 }
];
const sampleStock = [
    { product: "Gold Ring", quantity: 10, weight: 500, rate: 5500 },
    { product: "Silver Chain", quantity: 20, weight: 300, rate: 70 }
];
const samplePlans = [
    { user: "John Doe", plan: "Gold Plan", amount: 50000, paymentDate: "2026-03-01", status: "Paid" },
    { user: "Jane Smith", plan: "Silver Plan", amount: 20000, paymentDate: "2026-03-03", status: "Pending" }
];
export default function Reports() {
    const [tab, setTab] = useState(0);
    const handleTabChange = (_, newValue) => {
        setTab(newValue);
    };
    const getReportData = () => {
        switch (tab) {
            case 0:
                return {
                    columns: ["S.No", "Order ID", "Date", "Customer", "Total", "Status"],
                    rows: sampleOrders.map((o, i) => [i + 1, o.orderId, o.date, o.customer, `₹${o.total.toLocaleString()}`, o.status])
                };
            case 1:
                return {
                    columns: ["S.No", "Invoice ID", "Date", "Customer", "Total Amount"],
                    rows: sampleInvoices.map((inv, i) => [i + 1, inv.invoiceId, inv.date, inv.customer, `₹${inv.totalAmount.toLocaleString()}`])
                };
            case 2:
                return {
                    columns: ["S.No", "Product", "Quantity", "Weight (g)", "Rate (₹)"],
                    rows: sampleStock.map((s, i) => [i + 1, s.product, s.quantity, s.weight, s.rate])
                };
            case 3:
                return {
                    columns: ["S.No", "User", "Plan", "Amount (₹)", "Payment Date", "Status"],
                    rows: samplePlans.map((p, i) => [i + 1, p.user, p.plan, p.amount, p.paymentDate, p.status])
                };
            default:
                return { columns: [], rows: [] };
        }
    };
    const { columns, rows } = getReportData();
    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h5" sx={{ mb: 3 }}>Reports</Typography>
            <Tabs value={tab} onChange={handleTabChange} sx={{ mb: 2 }}>
                <Tab label="Order Report" />
                <Tab label="Invoice Report" />
                <Tab label="Stock Report" />
                <Tab label="Plan Payment Report" />
            </Tabs>
            <DataTable columns={columns} rows={rows} loading={false} />
        </Box>
    );
}